module.exports = __webpack_public_path__ + "img/vaf.819bc95f.svg";